import { render, staticRenderFns } from "./help_open_tutorial.vue?vue&type=template&id=2da9fa31&scoped=true&"
import script from "./help_open_tutorial.vue?vue&type=script&lang=js&"
export * from "./help_open_tutorial.vue?vue&type=script&lang=js&"
import style0 from "./help_open_tutorial.vue?vue&type=style&index=0&id=2da9fa31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da9fa31",
  null
  
)

export default component.exports